<template>
  <div>
    <label class="mb-3">
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <b-row>
      <b-col cols="2" sm="1" class="pr-0">
        <span class="bg-main text-light rounded-circle px-2 py-1">
          <span v-if="selected">
            {{ selected }}
          </span>
          <span v-else>
            0
          </span>
        </span>
      </b-col>
      <b-col cols="10" sm="11" class="pl-0">
        <b-form-input
          id="range-1"
          v-model="selected"
          type="range"
          :min="min_value"
          :max="max_value"
          :required="!selected && required"
          @change="handleChangeElement({ id, value: selected })"
        ></b-form-input>
      </b-col>
    </b-row>
    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import modal from '@/components/practice/modalQuestionPlan.vue';

export default {
  components: {
    modal,
  },
  props: {
    min_value: Number,
    max_value: Number,
    min_label: String,
    max_label: String,
    question: String,
    index: Number,
    id: Number,
    answers: Array,
    questionPlan: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixinListenerChangeElement],
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  data() {
    return {
      selected: null,
      modalQuestion: false,
    };
  },
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then(() => {
        this.modalQuestion = true;
      });
    },
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.answers.forEach((element) => {
        this.selected = element.answer_number;
      });
    }
  },
};
</script>
